import MicroModal from 'micromodal';

const options = {
  onShow: (modal) => {
    history.replaceState(null, null, `#${modal.id}`);
  },
  onClose: (modal) => {
    history.replaceState(null, null, '#');
  },
  openTrigger: 'data-modal-open',
  closeTrigger: 'data-modal-close',
  disableScroll: true,
  disableFocus: true,
  awaitCloseAnimation: true,
};

/**
 * Only initialize MicroModal if there's a modal on the current page.
 */
if (document.querySelector('.js-modal')) {
  // Append modals to end of </body>, to avoid issues with position: relative
  // parent elements (eg. Flickity carousels).
  Array.from(document.querySelectorAll('.js-modal')).forEach((modal) =>
    document.body.appendChild(modal)
  );
  MicroModal.init(options);
}

/**
 * Retrieve the hash from the URL (if it exists), minus the number sign.
 * @param {String} url
 */
function parseHash(url) {
  if (!url.includes('#')) {
    return null;
  }
  return url.split('#').pop();
}

/**
 * Automatically open/close modals when the url hash changes, if the hash
 * matches an existing modal id.
 * @param {Event} event
 */
function handleHashchange(event) {
  let newHash = parseHash(event.newURL);
  let oldHash = parseHash(event.oldURL);

  if (newHash && document.querySelector(`.js-modal[id="${newHash}"]`)) {
    MicroModal.show(newHash, options);
  }

  if (oldHash && document.querySelector(`.js-modal[id="${oldHash}"]`)) {
    MicroModal.close(oldHash, options);
  }
}
window.addEventListener('hashchange', handleHashchange);

/**
 * Automatically open a modal if its id is the url hash.
 */
function handleDOMContentLoaded() {
  const id = window.location.hash.substr(1);
  if (document.querySelector(`.js-modal[id="${id}"]`)) {
    MicroModal.show(id, options);
  }
}
window.addEventListener('DOMContentLoaded', handleDOMContentLoaded);

// Prevent any modal "anchor links" from scrolling down the page.
[...document.querySelectorAll('[href^="#"]')].forEach((link) => {
  link.addEventListener('click', (event) => {
    const hash = parseHash(link.href);
    // If there's a matching modal, prevent scrolling and manually update hash
    // (to trigger handleHashchange above).
    if (document.querySelector(`.js-modal[id="${hash}"]`)) {
      event.preventDefault();
      window.location.hash = hash;
    }
  });
});
